import { axiosInstance } from './axios'

export const httpService = axiosInstance

httpService.interceptors.request.use(
  async function (config) {
    const user = await localStorage.getItem('@SYGO-CRM-USER')
    let token = ''

    if (user) {
      token = JSON.parse(user || '').accessToken
    }

    config.headers['x-access-token'] = token

    return config
  },

  function (error) {
    Promise.reject(error)
  }
)

httpService.interceptors.response.use(
  function (response) {
    return response
  },

  function (error) {
    if (error.response.status === 403) localStorage.removeItem('@SYGO-CRM-USER')
    return Promise.reject(error)
  }
)
